/**
 * This file includes polyfills needed by Angular and is loaded before the app.
 */

/***************************************************************************************************
 * BROWSER POLYFILLS
 */

import 'core-js/stable';

import 'url-search-params-polyfill';
import 'formdata-polyfill';
import 'mutation-observer';
import 'flexibility';
import 'mutationobserver-shim';
import 'dialog-polyfill';

if (!Element.prototype.matches) {
    Element.prototype.matches = (<any>Element.prototype).msMatchesSelector ||
      Element.prototype.webkitMatchesSelector;
  }

import 'classlist.js';
import 'web-animations-js';

/***************************************************************************************************
 * Zone JS is required by Angular itself.
 */
import 'zone.js/dist/zone';
